import { render } from "./AuthorArticleSelect.vue?vue&type=template&id=2dbd0f7c&scoped=true"
import script from "./AuthorArticleSelect.vue?vue&type=script&lang=js"
export * from "./AuthorArticleSelect.vue?vue&type=script&lang=js"

import "./AuthorArticleSelect.vue?vue&type=style&index=0&id=2dbd0f7c&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2dbd0f7c"]])

export default __exports__